import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reload",
  "use": "reload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"reload\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.77 20.047c3.228-.362 5.814-2.942 6.183-6.17.483-4.221-2.798-7.814-6.91-7.86V4.124c0-.106-.131-.161-.22-.096L7.924 6.891a.12.12 0 000 .194l3.899 2.863c.088.066.22.007.22-.095v-1.89c2.89.046 5.204 2.505 5.006 5.444-.167 2.527-2.228 4.579-4.756 4.74a5.105 5.105 0 01-5.365-4.274.971.971 0 00-.96-.812.963.963 0 00-.956 1.105 7.048 7.048 0 007.758 5.88z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol